import { z } from 'zod';

export const inicialSchema = z.object({
  nome: z.string().min(1, 'Nome é obrigatório'),
  idFuncionario: z.number().optional(),
  celular: z.string().min(11, 'Celular deve conter 11 caracteres'),
});
